import defer from './promise-defer';

const zipCodeLocalizer = {

  validate: async (Localizer, zipCode) => {
    const promiseDefer = defer();
    const zipCodeRegex = /^\d{5}$/;

    if (!zipCode.match(zipCodeRegex)) {
      return Promise.resolve(false);
    }
    Localizer.validateUSZipcode(
      zipCode,
      () => promiseDefer.resolve(true), // successCalback
      () => promiseDefer.reject(), // failureCallback
      () => promiseDefer.reject(), // errorCalllback
    );

    return promiseDefer.promise;
  },

  update: (Localizer, zipCode) => {
    Localizer.updateDeliveryZipcodeDetails(zipCode, 'USER');
  },
  updateDeliveryZipCode: async (localizerRef, searchInput, onSuccessfulUpdate) => {
    try {
      const isValid = await zipCodeLocalizer.validate(localizerRef.current, searchInput);
      if (isValid) {
        onSuccessfulUpdate();
      }
    } catch (error) {
      // eslint-disable-next-line
        console.warn(`Error occurred while validating Localizer - ${error}`);
    }
  },
};

export default zipCodeLocalizer;